import { get, post } from "./http";

const CifuAPI = {
  login: async (data) => await post("/api/user/mobilelogin", data), // 登录
  register: async (data) => await post("/api/user/register", data), // 注册
  getUserInfo: async (params) => await get("/api/user/getUserInfo", params), // 获取用户信息
  updateUserInfo: async (data) => await post("/api/user/profile", data), //编辑个人信息
  getDeptList: async (params) => await get("/api/jobs/getJobCategory", params), // 获取部门列表
  getJobList: async (params) => await get("/api/jobs/getList", params), // 岗位列表
  getJobDetail: async (params) => await get("/api/jobs/detail", params), //岗位详情
  apply: async (data) => await post("/api/jobs/apply", data), //申请岗位
  applyList: async (params) => await get("/api/jobs/getApplyList", params), //申请列表
  applyDetail: async (params) => await get("/api/jobs/getApplyInfo", params), //申请详情
  getBannerList: async (params) => await get("/api/banner/getList", params), //获取banner图列表
  getConfig: async () => await get("/api/common/config"), //获取系统配置
  getReportType: async () => await get("/api/report/getType"), //获取报告类型
  getReportList: async (params) => await get("/api/report/getList", params), //  获取报告列表
  getLinkType: async () => await get("/api/links/getType"), //获取链接类型
  getLinkList: async (params) => await get("/api/links/getList", params), //获取友情链接
  getArticleList: async (params) => await get("/api/document/getList", params), //文章列表
  getArticleDetail: async (params) => await get("/api/document/getContentInfo", params), //获取文章详情
  getArticleType: async (params) => await get("/api/document/getCate", params), //获取文章分类
  getCertificateList: async (params) => await get("/api/cert/getList", params), //资质证书
  getBottomIcons: async () => await get("/api/common/getBottomIcons"), //获取底部图标
  getProjectList: async (params) => await get("/api/project/getList", params), //项目列表
  getProjectDetail: async (params) => await get("/api/project/getInfo", params), //项目详情
  upload: async (data) => await post("/api/common/upload", data), //上传图片
  getDonateList: async (params) => await get("/api/project/getPayList", params), //捐赠动态
  applyCert: async (data) => await post("/api/project/zhengshu_apply", data), //证书申领
  batchApplyCert: async (data) => await post("/api/project/zhengshu_apply_import", data), //批量证书申领
  getApplyCertList: async (params) => await get("/api/project/zhengshu_apply_list", params), //证书申领记录
  applyBill: async (data) => await post("/api/project/fapiao_apply", data), //票据申领
  batachApplyBill: async (data) => await post("/api/project/fapiao_apply_import", data), //票据批量申领
  getFundraisingPlatform: async () => await get("/api/common/getFundraisingPlatform"), //获取公开募捐平台
  getCountData: async () => await get("/api/common/getCountData"), //首页统计数据
  getCateList: async () => await get("/api/project/getCateList"), //项目分类
  downloadTemplate: async () => await get("/api/common/getImportTmp"), //下载模板
  getSmsCode: async (data) => await post('/api/sms/send', data) // 发送验证码
};

export default CifuAPI;
